<template>
    <div :class="serviceFieldStepClass">
        <div class="step-body">
            <div class="row">
                <div class="col-lg-1"><h4 class="step-num">1</h4></div>
                <div class="col-lg-11">
                    <div class="step-box">
                        <div v-if="showEditCancelButton" style="float:right;height:50px;line-height:50px;margin-bottom:20px;">
                            <a class="btn-step-select" style="color:#006DD0" v-on:click.stop="prevStep()">Edit</a>
                        </div>
                        <h4 class="step-title">Schedule Booking</h4>
                        <transition name="fade">
                            <booking-details v-if="bookingDetailsLength" :details="bookingDetails"></booking-details>
                        </transition>
                        <div v-if="stepIsValid" class="step-fields">
                            <form-field
                                v-bind:key="schedulingSteps[step].id"
                                v-bind:index="schedulingSteps[step].id"
                                v-bind:field="schedulingSteps[step]"
                                v-bind:defaultValue="getDefaultValueFromResponse(schedulingSteps[step].id)"
                            ></form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapGetters, mapState, mapMutations } from 'vuex';
  import FormField from '../FormField';
  import BookingDetails from './BookingDetails';
  import formMixin from '../../mixins/formMixin';
  import schedulingMixin from '../../mixins/schedulingMixin';

  export default {
    mixins: [formMixin,schedulingMixin],
    data() {
      return {
        errors: [],
        height: '',
      }
    },
    methods: {
        ...mapMutations('scheduling', [
          'addBookingDetails',
          'prevStep',
          'nextStep'
        ]),
        lastStep() {
            while(this.stepIsValid) {
                this.nextStep();
            }
        },
        getDefaultValueFromResponse(id) {
            if (this.$store.getters.response[id]) {
                return this.$store.getters.response[id].value;
            }
        }
    },
    created() {
        this.schedulingSteps.forEach(step => this.addBookingDetails({
            type: step.type,
            details: {}
        }));
    },
    computed: {
      ...mapGetters({
        formErrors: 'fieldsWithErrors',
        userInput: 'response',
      }),
      ...mapGetters('form', [
        'fields',
        'redirect',
        'inline_title',
        'inline_message'
      ]),
      ...mapGetters('scheduling', [
        'bookingDetails',
      ]),
      ...mapState('form', { form: 'form', formId: 'formId', confirmed: 'confirmed' }),
      ...mapState('scheduling', { step: 'step' }),
      bookingDetailsLength() {
         var i;
         for (i in this.bookingDetails) {
           if (Object.keys(this.bookingDetails[i]).length > 0) {
              if (i != 'location' || this.bookingDetails[i].id !== 0) {
                  return true;
              }
           }
         }
         return false;
      },
      bookingDetailsFullLength() {
        let i;
        let check = 0;
        for (i in this.bookingDetails) {
          if (Object.keys(this.bookingDetails[i]).length > 0) {
             check++;
          }
        }
        return check == Object.keys(this.bookingDetails).length
      },
      showEditCancelButton() {
        return (this.showCustomerStep || this.bookingDetailsFullLength) && !this.confirmed && !this.stepIsValid;
      },
      serviceFieldStepClass() {
          return {
              "scheduling-service-form-step":true,
              "step":true,
              "schedule-step":true,
              "open": this.stepIsValid
          }
      }
    },
    components: {
        FormField,
        BookingDetails,
    },
  };
</script>
